<template>
  <div class="card px-4 py-7 rounded-lg bg-transparent shadow mx-2" style="width: 500px !important;">
    <div class="d-flex align-items-center justify-content-between">
      <h3 class="card-title d-flex">
        <span class="text-capitalize">{{ getMonthLocalName(parseInt(month), year, $i18n.locale) + ' ' + year}}</span>
      </h3>
      <div>
        <span class="small fw-bold"
              :title="$t('tooltip.pipeline.month_gain_estimated')">
        {{ $formatLocalAmount(estimatedAmount) }} {{ currencyIso }} </span>
      </div>
    </div>
    <div class="d-flex my-4">
      <span class="badge badge-success rounded-4 min-w-30px d-flex justify-content-center"
            :title="$t('tooltip.pipeline.offer_concluded')">
       {{ $formatLocalAmount(concludedAmount) }} {{ currencySymbol }} </span>
      <span class="badge badge-warning rounded-4 min-w-30px ms-1 d-flex justify-content-center"
            :title="$t('tooltip.pipeline.total_opportunity')">
       {{ count }} </span>
      <span class="small ms-auto fw-bold"
            :title="$t('tooltip.pipeline.amount_opportunity')">
       {{ $formatLocalAmount(totalAmount) }} {{ currencyIso }} </span>
    </div>
    <div class="mt-7" style="height: 570px !important; padding: 5px !important; overflow-y: auto !important;">
      <PipelinePrevisionStepItem
          v-for="(opportunity, index) in opportunities"
          :key="index"
          :opportunity="opportunity"
          :currency="currencyIso"
          @click.prevent="goToOpportunityView(opportunity)"
          style="cursor:pointer;"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import PipelinePrevisionStepItem from "./PipelinePrevisionStepItem.vue";
import {$formatLocalAmount} from "@/mixins/Helpers";
import {useRouter} from "vue-router";

const props = defineProps({
  month: { type: String, default: '01' },
  year: { type: String, default: '2024' },
  opportunities: { type: Array, default: () =>  []},
  estimatedAmount: String|Number,
  concludedAmount: String|Number,
  totalAmount: String|Number,
  currencyIso: {type: String, default: ''},
  currencySymbol: {type: String, default: ''},
  count: { type: [String,Number], default: '0' }

})
const router = useRouter()


function getMonthLocalName(month, year, locale) {
  const date = new Date(year+"-"+month+"-"+"01")
  const options = { month: "long" };
  return new Intl.DateTimeFormat(locale, options).format(date)
}

function goToOpportunityView(opportunity){
  router.push({ name: 'pipelines-view', params: { id: opportunity.id } })
}
</script>

<style scoped>

</style>
